import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const SolutionSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-12 border-l-8 border-blue-900">
            <div className="flex items-start gap-4 mb-6">
              <CheckCircle2 className="w-12 h-12 text-green-600 flex-shrink-0" />
              <div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  E2-Return in One Sentence
                </h2>
                <p className="text-xl text-gray-700 leading-relaxed">
                  <span className="font-semibold text-blue-900">E2-Return</span> is an IoT tracking system that monitors returnable packaging assets (crates, pallets, containers, airport equipment) using a <span className="font-semibold text-red-600">BLE network for on-campus tracking</span> and <span className="font-semibold text-red-600">optional GPS for off-campus visibility</span> — eliminating losses, automating tracking, and providing real-time visibility across your entire supply chain.
                </p>
              </div>
            </div>
            
            <div className="mt-8 flex items-center justify-center">
              <img 
                src="https://images.unsplash.com/photo-1595692682118-774e5182f484"
                alt="IoT tracking technology"
                className="rounded-lg shadow-md max-h-48 object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
